import { Component, OnInit, OnDestroy,Injectable } from '@angular/core';
import {Http, Headers, RequestOptions,Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {ShareService} from './../services/services';
import 'rxjs/add/operator/publishReplay';

let headers = new Headers();
headers.append('Access-Control-Allow-Origin', '*');
headers.append('Content-Type', 'application/x-www-form-urlencoded');
let options = new RequestOptions({ headers: headers });	 

export class Contact {
    constructor(public slug: string, public description: string,public title: string) { }
}

@Injectable()
export class ContactService {

   
     public _siteinfo; 
    constructor(
      private http: Http,
      
      private shareService: ShareService) {
  
  
    }

	getPage(slug:string) {
	    //console.log(slug);
	    
	    let headers = new Headers({'X-CSRF-TOKEN':this.shareService.getToken()});
	    headers.append('Access-Control-Allow-Origin', '*');
		headers.append('Content-Type', 'application/x-www-form-urlencoded');
	    ///alert(this.getToken());
	     
	   let options= new RequestOptions({ headers:headers });
	   	let apirul=this.shareService.getApiUrl()+'/menu';	    
	   	if (!this._siteinfo) {  
        this._siteinfo= this.http.get(apirul,options)
             .map(res => res.json())
              .publishReplay(1)
			  .refCount()             
             .catch(this.handleError);  
       }
        return this._siteinfo;
        
	}
	
	
		doContactUs(params) {
	    //console.log(slug)
	    let headers = new Headers({'X-CSRF-TOKEN':this.shareService.getToken()});
	    headers.append('Access-Control-Allow-Origin', '*');
		headers.append('Content-Type', 'application/x-www-form-urlencoded');
	    ///alert(this.getToken());
	     
	   let options= new RequestOptions({ headers:headers });
	   
	   	let apirul=this.shareService.getApiUrl()+'/postcontactus';
	   	
	   	
         let formData = JSON.stringify(params);
         let body = 'request='+formData;	
             
	   	 
        let output= this.http.post(apirul,body,options)
             .map(res => res.json())
              .publishReplay(1)
			  .refCount()             
             .catch(this.handleError);  
       
        return output;
	         
      
	}
	handleError(error) {
        console.error("Got the error: " + JSON.stringify(error));
        return Observable.throw(error.json().error || 'Server error');
    }
}


// WEBPACK FOOTER //
// ./resources/assets/typescript/contact/contact.service.ts